import type { ReactNode } from "react";
import type { IndividualRecordCertificateData } from "./certificate-data";

export function IndividualRecordCertificate({ data }: { data: IndividualRecordCertificateData }) {
  return (
    <article className="certificate-page individual-record-certificate" aria-label="Individual Record of Barangay Inhabitant">
      <header className="certificate-header individual-record-header">
        <div className="logo-column" aria-label="Office logo">
          <img className="rbim-logo" src="/logos/RBIM.png" alt="Office logo" />
        </div>
        <div className="title-column">
          <h1 className="certificate-title"><span>INDIVIDUAL RECORD OF</span><span>BARANGAY INHABITANT</span></h1>
          <p className="certificate-subtitle">Registry of Barangay Inhabitants and Migrants (RBIM)</p>
        </div>
        <div className="photo-column"><PhotoBox photoUrl={data.photoUrl} /></div>
      </header>

      <hr className="header-divider individual-record-header-line" />

      <CertificateSection title="1. Location">
        <div className="individual-record-location-grid">
          <div className="individual-record-location-left">
            <LineField label="Province" value={data.location.province} />
            <LineField label="City / Municipality" value={data.location.cityMunicipality} />
            <LineField label="Barangay" value={data.location.barangay} />
          </div>
          <div className="individual-record-location-right">
            <LineField label="Household Number" value={data.location.householdNumber} />
          </div>
        </div>
      </CertificateSection>

      <CertificateSection title="2. Personal Information">
        <LineField label="Last Name" value={data.personal.lastName} />
        <LineField label="First Name" value={data.personal.firstName} />
        <LineField label="Middle Name" value={data.personal.middleName} />
        <LineField className="individual-record-field-tall" label="Address" value={data.personal.address} />
        <div className="individual-record-two-column">
          <LineField label="Date of Birth" value={data.personal.dateOfBirth} />
          <LineField label="Age" value={data.personal.age} />
        </div>
        <div className="individual-record-two-column">
          <LineField label="Place of Birth" value={data.personal.placeOfBirth} />
          <LineField label="Sex" value={data.personal.sex} />
        </div>
        <div className="individual-record-two-column">
          <LineField label="Civil Status" value={data.personal.civilStatus} />
          <LineField label="Occupation" value={data.personal.occupation} />
        </div>
        <div className="individual-record-two-column">
          <LineField label="Citizenship" value={data.personal.citizenship} />
          <LineField label="Date Issued" value={data.issuedDate} />
        </div>
        <LineField className="individual-record-relationship-field" label="Relationship to Household Head" value={data.personal.relationshipToHouseholdHead} />
      </CertificateSection>

      <section className="individual-record-certification">
        <p>I hereby certify that the above information are true and correct to the best of my knowledge.</p>
        <div className="individual-record-registrant-signature">
          <div className="individual-record-signature-line" />
          <strong>NAME &amp; SIGNATURE</strong><span>(Registrant)</span>
        </div>
      </section>

      <section className="individual-record-bottom">
        <div className="individual-record-attested">
          <h2>Attested By:</h2>
          <div className="individual-record-secretary-signature">
            <div className="individual-record-signature-line" />
            <strong>BARANGAY SECRETARY</strong><span>(Name &amp; Signature)</span>
          </div>
          <div className="individual-record-date-line"><strong>Date:</strong><span>{data.issuedDate}</span></div>
        </div>
        <div className="individual-record-thumbmarks">
          <h2>Thumbmarks</h2>
          <div className="individual-record-thumbmark-grid">
            <Thumbmark label="LEFT THUMBMARK" /><Thumbmark label="RIGHT THUMBMARK" />
          </div>
        </div>
      </section>

      <footer className="individual-record-footer">
        This document is issued by the Barangay Government for identification and record-keeping purposes only.
      </footer>
    </article>
  );
}

function CertificateSection({ children, title }: { children: ReactNode; title: string }) {
  return <section className="individual-record-section"><h2>{title}</h2><div className="individual-record-section-line" /><div className="individual-record-section-content">{children}</div></section>;
}

function LineField({ className = "", label, value }: { className?: string; label: string; value: string }) {
  return <div className={`individual-record-field ${className}`}><span className="individual-record-field-label">{label}</span><span className="individual-record-field-colon">:</span><span className="individual-record-field-value">{value}</span></div>;
}

function PhotoBox({ photoUrl }: { photoUrl: string }) {
  return <div className="photo-box individual-record-photo"><div className="photo-area">{photoUrl ? <img src={photoUrl} alt="Resident profile" /> : <div className="photo-silhouette individual-record-photo-silhouette" aria-hidden="true" />}</div><div className="photo-label individual-record-photo-label"><span>PHOTO</span><span>(2&quot; x 2&quot;)</span></div></div>;
}

function Thumbmark({ label }: { label: string }) {
  return <div className="individual-record-thumbmark"><div /><span>{label}</span></div>;
}
